export default {
  title: "Select Organization",
  groupsTitle: "Select Group",
  goToFullOrganization: "Go To Full Organization",
};
